<template>
  <div class="header">
    <div class="contentView">
      <div class="icon"></div>
      <div style="background: white; padding:2px 0">
        <div class="toolView">
          <div class="titleNav"
            v-for="(nav,index) in navObjs" 
            :key="nav.title"
            :style="{color:activeNav==nav.path?'#29A547':'#1E6F2B',
                    width:index%3==1?'24%':'',}"
            :class="{borderLR:(index%3==1),borderB:(index<3)}"
            @click="navBtnTouch(nav)">
            {{nav.title == '合作申请'?'':nav.title}}
            <a v-if="nav.title == '合作申请'" href="tel:400-0519-000">合作申请</a>
          </div>
          <div class="phoneView"><div class="phoneIcon"></div><a href="tel:400-0519-000">服务热线：4000-519-000</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      navObjs:[
        {
          title:'首页',
          path:'/'
        },
        {
          title:'产品介绍',
          path:'product'
        },
        {
          title:'合作申请',
          path:''
        },
        {
          title:'公司动态',
          path:'trends'
        },
        {
          title:'企业实力',
          path:'strength'
        },
      ]
    };
  },
  components: {},
  mounted () {},
  computed: {
    activeNav: function () {
      const route = this.$route;
      const pathArr = route.path.split("/");
      const path = pathArr[1]==''?'/':pathArr[1];
      return path;
    },
  },
  methods: {
    navBtnTouch(nav) {
      this.navSel = nav.title;
      this.$router.push(nav.path);
    },
  }
}
</script>

<style lang='scss' scoped>
a{
  color: #1E6F2B;
  text-decoration:none;
}
.header{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  color: black;
  z-index: 1000;
  font-weight: 500;
  box-shadow: 0 0 10px #ddd;
}
.contentView{
  background:#2AA547;
  max-width: 7.5rem;
  margin: auto;
  padding-top: 0.2rem;
  box-sizing: border-box;
}
.icon{
  width: 0.88rem;
  height: 0.65rem;
  margin: auto;
  background-image: url("../assets/img/sulv_logo.png");
  background-size: 100% 100%;
  margin: 0 auto 0.02rem auto;
}
.toolView{
  display: flex;
  flex-wrap:wrap;
  width: 94%;
  margin: 0 auto;
}
.titleNav{
  font-size: 0.18rem;
  height: 0.6rem;
  line-height: 0.6rem;
  width: 38%;
  box-sizing: border-box;
}
.phoneView{
  width: 38%;
  font-size: 0.16rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.phoneIcon{
  width: 0.15rem;
  height: 0.15rem;
  background-image: url("../assets/img/phone.png");
  background-size: 100% 100%;
  margin: 0 0.05rem 0.04rem 0;
}
.borderLR{
  border-left: 1px dashed#268C40;
  border-right: 1px dashed #268C40;
}
.borderB{
  border-bottom: 1px dotted #268C40;
  margin-bottom: 2px;
}
</style>
